import { render, staticRenderFns } from "./OrderDetailFooter.vue?vue&type=template&id=882fd59e&scoped=true"
import script from "./OrderDetailFooter.vue?vue&type=script&lang=ts"
export * from "./OrderDetailFooter.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetailFooter.vue?vue&type=style&index=0&id=882fd59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882fd59e",
  null
  
)

export default component.exports